import { datadogReportLogs } from 'utils/tinkReports';
import { frameConfigBasic } from '../../../AppConfig';
import { getScreenTranslation } from '../../../utils/translations';
import { RequestLoadingTemplate } from 'InternalLibrary';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useClient from 'hooks/useClient';
import useFirebase from 'hooks/useFirebase';
import useResolutionResolverOnlineBank from './useResolutionResolverOnlineBank';

export default function OnlineBankWaiting() {
  useResolutionResolverOnlineBank();
  const { client } = useClient();
  const { firebaseData } = useFirebase();
  const i18Next = useTranslation();

  useEffect(() => {
    if (firebaseData.REGISTRATION_DATADOG_LOGS_INFO && client?.id) {
      datadogReportLogs('onlineBankWaiting', client);
    }
  }, [client?.id, firebaseData.REGISTRATION_DATADOG_LOGS_INFO]);

  return (
    <RequestLoadingTemplate
      {...frameConfigBasic}
      hideLogout
      hideMobileFooter
      content={getScreenTranslation(
        'online_bank_identification_waiting',
        i18Next,
      )}
      sectionID={0}
      logoSquare
      logo
    />
  );
}
